import moment from 'moment';
import { toast } from 'react-toastify';

const browserStorage = localStorage;
const sessionStore = sessionStorage;

export function checkIfTokenRefreshIsRequired() {
   if (!isTokenStillValid()) clear();
}

export function isTokenStillValid() {
   const expiryTime = getExpiryTime();
   return isTokenNotExpired(expiryTime);
}

export function isUnsafeTokenExpiryDateValid(expiresValue) {
   if (!expiresValue) return false;
   const expiryTime = moment.utc(expiresValue);
   return isTokenNotExpired(expiryTime);
}

export function isTokenNotExpired(expiryTimeMoment) {
   const now = moment.utc();
   const expiryTime = expiryTimeMoment;
   // console.log('expiryTime => ', expiryTime ? expiryTime.format() : expiryTime);
   if (!expiryTime) return false;
   // return now.isBefore(expiryTime.clone().subtract(23, 'hour').subtract(59, 'minute'));

   // add 1 minute buffer in case of clock drift
   return now.isBefore(expiryTime.clone().subtract(1, 'minute'));
}

export function setItem(key, value) {
   browserStorage.setItem(key, value);
}

export function getItem(key) {
   return browserStorage.getItem(key);
}

export function removeItem(key) {
   browserStorage.removeItem(key);
}

export function clear(showToast = true) {
   if (getUserInfo()) {
      if (showToast) toast.info('Your session has expired. Please login again.');
      browserStorage.clear();
   }
}

export function getUserInfo() {
   const userInfo = getItem('userInfo');
   return userInfo ? JSON.parse(userInfo) : null;
}

export function getExpiryTime() {
   const userInfo = getUserInfo();
   return userInfo?.expires ? moment.utc(userInfo.expires) : null;
}

export function getJwtToken() {
   const userInfo = getUserInfo();
   return userInfo?.token ? userInfo.token : '';
}

export function setSessionItem(key, value) {
   sessionStore.setItem(key, value);
}

export function getSessionItem(key) {
   return sessionStore.getItem(key);
}

export function removeSessionItem(key) {
   sessionStore.removeItem(key);
}
